<mat-accordion>
	<mat-expansion-panel [expanded]="panelOpenState" (opened)="panelOpenState = true" (closed)="panelOpenState = false"
		hideToggle (click)="toggle($event)">
		<mat-expansion-panel-header (click)="$event.stopImmediatePropagation();" #header>
			<mat-panel-title (click)="toggle($event); $event.stopImmediatePropagation();" [ngClass]="{'pt-24': panelOpenState}">
				<img class="img" fallback="../../../assets/images/thumbnail.png" dynamicImage [baseImageSrc]="model?.image" [displayResolutions]="[RESOLUTIONS.xs]" alt="{{model?.name}}">
				<div class="container">
					<div class="title-container" [ngClass]="{'mt-24': panelOpenState}">
						<div class="flex center gap-10">
							<h2 class="title">{{model?.name | customTitleCase}}</h2>
							<mat-icon svgIcon="dot" class="dot"></mat-icon>
							<div (click)="copyId($event,model?.id)" class="flex width-adapt gap-6 center pointer">
								<p class="grey-text">{{ 'ID' + ' ' + model?.id }}</p>
								<mat-icon svgIcon="copy" [matTooltip]="'general.copy_to_clipboard' | translateWithKeys" class="copy-id-icon"></mat-icon>
							</div>
						</div>
						<div class="flex center gap-5 action-buttons">
							<div class="btn" (click)="$event.stopImmediatePropagation()">
								<app-three-dots [model]="model" [manageClients]="true" [isAssignedByAdmin]="isAssigned" (action)="handleAction($event)">
								</app-three-dots>
							</div>

							<button class="drop-btn" mat-icon-button (click)="toggle($event); header._toggle(); $event.stopImmediatePropagation()">
								<mat-icon class="btn drop-icon"
									[ngClass]="{'rotate-180': panelOpenState, 'rotate-0': !panelOpenState}"
									svgIcon="drop_icon">
								</mat-icon>
							</button>
						</div>

					</div>
					<div class="flex gap-16">
						<mat-chip *ngIf="!isAssigned"
							[ngClass]="{'cat-published': model?.status === publishStatusEnum.PUBLISHED,'grey-chip': model?.status === publishStatusEnum.DRAFT} ">
							{{'general.'+publishStatusEnum[model?.status] | lowercase | translateWithKeys}}
						</mat-chip>
						<div class="flex start-center gap-5">
							<mat-icon class="icon" svgIcon="book_closed"></mat-icon>
							<p>{{model?.courses.length}} {{'general.courses' | translateWithKeys}}</p>
						</div>
						<div class="flex start-center gap-5">
							<mat-icon class="icon" svgIcon="quiz_interrogation"></mat-icon>
							@if (questionsLoading) {
								<ngx-skeleton-loader [theme]="{ 'width': '60px', 'height': '14px', 'margin': '0' }"></ngx-skeleton-loader>
							} @else {
								<p>{{totalQuestions}} {{'course-creation.questions' | translateWithKeys}}</p>
							}
						</div>
						<div class="flex start-center gap-5">
							<mat-icon class="icon" svgIcon="calendar"></mat-icon>
							<p>{{(model?.createdAt?.seconds * 1000) | appDate }}</p>
						</div>
						<div class="flex start-center gap-5"appTooltip [tooltipTemplate]="tooltipLanguage"
						[tooltipContext]="{ implicit: model?.languages }" [tooltipTop]="5">
							<mat-icon class="icon" svgIcon="language"></mat-icon>
							<p>{{model?.languages.length}} {{'general.languages' | translateWithKeys}}</p>
						</div>
						@if (assignedClients.length) {
							<div class="flex start-center gap-5" appTooltip [tooltipTemplate]="assignedClients.length ? tooltipClients : null"
								[tooltipContext]="{ implicit: assignedClients }" [tooltipTop]="5">
								<mat-icon class="icon" svgIcon="person"></mat-icon>
								<p>{{assignedClients.length ? (assignedClients.length + ' ' + (assignedClients.length === 1 ? 'Client' : 'Clients')) : ''}}</p>
							</div>
						}
						@if (model?.duration) {
							<div class="flex start-center gap-5">
								<mat-icon class='icon' svgIcon="clock"></mat-icon>
								<p>{{ model?.duration | timeFormat }}</p>
							</div>
						}
						<div class="flex start-center gap-5" appTooltip [tooltipTemplate]="tooltipEnrollments"
						[tooltipContext]="{ implicit: model?.enrollments }" [tooltipTop]="5">
							<mat-icon class='icon' svgIcon="manage_users"></mat-icon>
							<p>{{ model?.enrollments | number }} {{ model?.enrollments === 1 ? ('general.user_enrolled' | translateWithKeys) : ('general.users_enrolled' | translateWithKeys) }} </p>
						</div>
					</div>
					<div class="description-container">
						<p [ngClass]="{'truncate': !panelOpenState, 'full-decription': panelOpenState}">{{model?.description}}</p>
					</div>
				</div>
			</mat-panel-title>
		</mat-expansion-panel-header>
		@if(courses.length){
			<div class="content" #containerCard>
				<div class="courses-container flex space-between">
					<h3 class="courses-title">{{'general.courses' | translateWithKeys | uppercase }}
						({{courses.length}})</h3>
					@if(courses.length > 5){
					<button mat-button class="title2" (click)="toggleShowAll(); $event.stopImmediatePropagation() ">{{ (showAll ? 'general.view_less' :
						'general.view_all') | translateWithKeys}} </button>
					}
				</div>
				<div class="flex row gap-16 mt-10 wrap normalHeight" [ngClass]="{'showHeight': showAll}">
					@for (course of courses; track $index) {
						<div #smallCard [ngClass]="{'pointer': userRole === userRoleEnum.CONTENT_CREATOR || userRole === userRoleEnum.ADMIN}"
						(click)="userRole === userRoleEnum.CONTENT_CREATOR || userRole === userRoleEnum.ADMIN ? goToPreviewCourse(course) : null">
							<app-course-card [cardType]="courseCardType.MINI" [course]="course"></app-course-card>
						</div>
					}
				</div>
			</div>
		}
	</mat-expansion-panel>
</mat-accordion>
<ng-template #tooltipLanguage let-languages="implicit">
	@if(languages.length){
		<div class="flex tooltip">
			@for(language of languages; track $index){
			<mat-chip class="colorLanguage">{{language?.name | translateWithKeys}}</mat-chip>
			}
		</div>

	}
</ng-template>
<ng-template #tooltipEnrollments let-enrollments="implicit">
	@if (enrollments > 0) {
		<div class="flex row bg-primary pad-tooltip">
			<span>{{ 'general.enrolled_users_info' | translateWithKeys }}</span>
		</div>
	}
</ng-template>
<ng-template #tooltipClients let-clients="implicit">
	<div class="flex tooltip">
		@for(client of clients; track $index){
		<mat-chip class="colorLanguage">{{client?.username || client?.email || client?.name}}</mat-chip>
		}
	</div>
</ng-template>
